import DropdownMenu from '@pelckmans/elementis/components/dropdown-menu';
import AccountContext from '../../contexts/AccountContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Pill from '@pelckmans/elementis/components/pill';
import useLogout from '../../hooks/useLogout';
import { capitalize } from '../../utils/string';

type UserMenuProps = {
  referenceEl: HTMLElement | null;
};

function UserMenu({ referenceEl }: UserMenuProps) {
  const { t } = useTranslation();
  const {
    account: { role, displayName },
  } = useContext(AccountContext);

  const logOut = useLogout();

  return (
    <DropdownMenu
      referenceEl={referenceEl}
      menuProps={{ ariaLabel: t('APP_NAV.SIDE_NAV.USER_MENU.A11Y_LABEL'), id: 'user-menu' }}
      role="menu"
      placement="right-end"
      offset={20}
      grow
      showSeparators
      zIndex={4}
    >
      <DropdownMenu.Item
        onClick={() => {}}
        value={null}
        role="menuitem"
        text={displayName!}
        subText={t('APP_NAV.SIDE_NAV.USER_MENU.EDIT')}
        pillGroupProps={{
          role: 'group',
          'aria-label': t('PAGES.MY_GROUPS.LIST_GROUP.SUBJECTS.A11Y_LABEL'),
          children: <Pill key={1}>{capitalize(t(role))}</Pill>,
        }}
      />
      <DropdownMenu.Item
        onClick={() => {}}
        value={null}
        role="menuitem"
        text={t('APP_NAV.SIDE_NAV.USER_MENU.INFO_AND_HELP')}
      />
      <DropdownMenu.Item
        onClick={logOut}
        value={null}
        role="menuitem"
        text={t('APP_NAV.SIDE_NAV.USER_MENU.SIGN_OUT')}
        prominence="danger"
      />
    </DropdownMenu>
  );
}

export default UserMenu;
